import React from "react";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_DP01Knapsack = () => (
  <DAAModuleSubtopic
    title="Dynamic Programming – 0/1 Knapsack Problem"
    videos={[
      "https://www.youtube.com/embed/nLmhmB6NzcM",
      "https://www.youtube.com/embed/zRza99HPvkQ",
      "https://www.youtube.com/embed/PfkBS9qIMRE"
    ]}
    takeaways={[
      { text: "Goal: Maximize the total value in the knapsack without exceeding its capacity." },
      { text: "Each item can either be taken once or not at all — that's why it's called 0/1 knapsack." },
      { text: "Time Complexity: O(n × W), where n is the number of items and W is the knapsack capacity." },
      { text: "Space Complexity: O(n × W), can be optimized to O(W) using a 1D array in reverse order." }
    ]}
    questions={[
      {
        text: "Consider a knapsack bag with n = 4, values = {10, 12, 12, 18}, and weights = {2, 4, 6, 9}. Max weight W = 15. Find the maximum value subset using dynamic programming and derive time complexity."
      }
    ]}
    exampleVideos={[
      "https://www.youtube.com/embed/5JXz5VEg_g8"
    ]}
  />
);

export default DAA_DP01Knapsack ;
